module.exports = __webpack_public_path__ + "media/V130.6766381f.mp4";